import utils from 'hey-utils';
// 定义正则表达式，用于匹配制表符、回车符、换行符和换页符
const rclass = /[\t\r\n\f]/g;
/**
 * 该对象继承了 hey-utils 的功能，并添加了 getClass 和 hasClass 方法
 */
export default utils.extend({}, utils, {
  /**
   * 获取元素的 class 属性值
   * @param {Element} elem - 需要获取 class 属性的 DOM 元素
   * @returns {string} - 元素的 class 属性值，如果不存在则返回空字符串
   */
  getClass(elem) {
    // 使用 getAttribute 方法获取元素的 class 属性，若不存在则返回空字符串
    return (elem.getAttribute && elem.getAttribute('class')) || '';
  },
  /**
   * 检查元素是否包含指定的类名
   * @param {Element} elem - 需要检查的 DOM 元素
   * @param {string} selector - 需要检查的类名
   * @returns {boolean} - 如果元素包含指定类名则返回 true，否则返回 false
   */
  hasClass(elem, selector) {
    let className;
    // 在类名前后添加空格，方便后续的字符串匹配
    className = ` ${selector} `;
    // 检查元素是否为元素节点，并且元素的 class 属性中是否包含指定类名
    if (elem.nodeType === 1 && (` ${this.getClass(elem)} `)
        // 替换元素 class 属性值中的特殊空白字符为普通空格
      .replace(rclass, ' ')
        // 检查处理后的 class 属性值中是否包含指定类名
      .indexOf(className) > -1) {
      return true;
    }

    return false;
  }
});
